import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';

export const actionTypes = {
  BRANCH_ITEM_ADD: 'BRANCH_ITEM_ADD',
  BRANCH_ITEM_CLEAR: 'BRANCH_ITEM_CLEAR',
  BRANCH_ITEM_SET: 'BRANCH_ITEM_SET',
  BRANCH_ITEM_UPDATE: 'BRANCH_ITEM_UPDATE',

  BRANCH_PATCH_FAILURE: 'BRANCH_PATCH_FAILURE',
  BRANCH_PATCH_REQUEST: 'BRANCH_PATCH_REQUEST',
  BRANCH_PATCH_SUCCESS: 'BRANCH_PATCH_SUCCESS',

  BRANCHES_CLEAR: 'BRANCHES_CLEAR',

  BRANCHES_GET_FAILURE: 'BRANCHES_GET_FAILURE',
  BRANCHES_GET_REQUEST: 'BRANCHES_GET_REQUEST',
  BRANCHES_GET_SUCCESS: 'BRANCHES_GET_SUCCESS',

  BRANCHES_POST_FAILURE: 'BRANCHES_POST_FAILURE',
  BRANCHES_POST_REQUEST: 'BRANCHES_POST_REQUEST',
  BRANCHES_POST_SUCCESS: 'BRANCHES_POST_SUCCESS',
};

export const actionCreators = {
  clear: () => ({
    type: actionTypes.BRANCHES_CLEAR,
  }),

  getRequest: () => ({
    type: actionTypes.BRANCHES_GET_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.BRANCHES_GET_SUCCESS,
    [ERROR_ACTION]: actionTypes.BRANCHES_GET_FAILURE,
  }),
  getSuccess: (branches: any) => ({
    type: actionTypes.BRANCHES_GET_SUCCESS,
    payload: { branches },
  }),
  getFailure: (error: Error) => ({
    type: actionTypes.BRANCHES_GET_FAILURE,
    error,
  }),

  itemAdd: () => ({
    type: actionTypes.BRANCH_ITEM_ADD,
  }),
  itemClear: () => ({
    type: actionTypes.BRANCH_ITEM_CLEAR,
  }),
  itemSet: (branch: any) => ({
    type: actionTypes.BRANCH_ITEM_SET,
    payload: { branch },
  }),
  itemUpdate: (branch: any) => ({
    type: actionTypes.BRANCH_ITEM_UPDATE,
    payload: { branch },
  }),

  patchRequest: (branch: any) => ({
    type: actionTypes.BRANCH_PATCH_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.BRANCH_PATCH_SUCCESS,
    [ERROR_ACTION]: actionTypes.BRANCH_PATCH_FAILURE,
    payload: { branch },
  }),
  patchSuccess: (branch: any) => ({
    type: actionTypes.BRANCH_PATCH_SUCCESS,
    payload: { branch },
  }),
  patchFailure: (error: Error) => ({
    type: actionTypes.BRANCH_PATCH_FAILURE,
    error,
  }),

  postRequest: (branches: Array<any>) => ({
    type: actionTypes.BRANCHES_POST_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.BRANCHES_POST_SUCCESS,
    [ERROR_ACTION]: actionTypes.BRANCHES_POST_FAILURE,
    payload: { branches },
  }),
  postSuccess: (branches: any) => ({
    type: actionTypes.BRANCHES_POST_SUCCESS,
    payload: { branches },
  }),
  postFailure: (error: Error) => ({
    type: actionTypes.BRANCHES_POST_FAILURE,
    error,
  }),
};

export default {
  create: actionCreators,
  type: actionTypes,
};
